import { Backdrop, Dialog, Stack, styled } from "@mui/material";

export const StyledBackDrop = styled(Backdrop)`
  background: transparent;
  transition: opacity 0.35s ease !important;
`;

export const CustomDialog = styled(Dialog)`
  & ::-webkit-scrollbar-thumb {
    height: 51px;
    width: 4px;
    background-color: #ac8d75;
  }

  & ::-webkit-scrollbar {
    width: 4px;
  }

  & ::-webkit-scrollbar-track {
    background-color: #5c412a;
    margin: 4px 4px 8px 0;
  }

  .MuiDialog-paper {
    overflow: hidden;
    overflow-y: hidden;
    max-height: calc(100dvh - 64px);
    height: fit-content;
    margin: 0 8px;
    /* ── PREVIEW: static gradient extracted from bg.png (2026-05-12) ──
       Replaces the live backdrop-filter blur so the modal always shows
       the "perfect" look from the homepage hero, regardless of page or
       scroll position. To revert, swap the next 3 lines back in:
         background: rgba(220, 180, 150, 0.15);
         backdrop-filter: blur(64px);
         -webkit-backdrop-filter: blur(64px);
    */
    background:
      /* Three overlapping radial "lobes" — each is roughly elliptical
         on its own, but offset positions + different sizes break the
         perfect-circle look so the highlight reads as an organic cloud
         instead of a stamped shape. */
      radial-gradient(
        ellipse 45% 40% at 42% -3%,
        rgba(176, 144, 105, 0.9) 0%,
        rgba(160, 128, 90, 0.5) 35%,
        transparent 75%
      ),
      radial-gradient(
        ellipse 55% 50% at 58% 3%,
        rgba(170, 140, 100, 0.75) 0%,
        rgba(140, 110, 78, 0.35) 45%,
        transparent 85%
      ),
      radial-gradient(
        ellipse 70% 35% at 50% 8%,
        rgba(150, 118, 82, 0.4) 0%,
        transparent 70%
      ),
      linear-gradient(
        180deg,
        rgb(153 112 75) 0%,
        rgb(99, 74, 54) 50%,
        rgb(111 83 60) 100%
      );
    border: none;
    border-radius: 24px;
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.7), 0 20px 60px rgba(0, 0, 0, 0.6);
    /* The Dialog uses MUI's Fade TransitionComponent (set via TransitionProps in
       the JSX wrapper). MUI drives opacity 0→1 on enter and 1→0 on exit via
       inline styles on this element. We supply a transform tween that runs in
       parallel for the slide-up-on-enter / settle-down-on-exit feel. The keyword
       'all' on the transition lets Fade's inline opacity transition cleanly
       alongside our transform. */
    transition: opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1),
                transform 0.35s cubic-bezier(0.4, 0, 0.2, 1) !important;
    transform: translateY(0) scale(1);
  }

  /* Closed-state paper (visible during the exit transition while MUI keeps
     the node mounted): mirrors the from-state of the old slideUp keyframes.
     MUI sets MuiDialog-paper's opacity inline via Fade; we layer the
     transform on top for the slight slide. */
  &[data-state="closing"] .MuiDialog-paper,
  .MuiDialog-paper.dialog-closing {
    transform: translateY(12px) scale(0.98);
  }

  @media only screen and (min-width: 1250px) {
    .MuiDialog-paper {
      width: 70%;
      max-width: 650px;
    }
  }

  @media only screen and (max-width: 1250px) {
    .MuiDialog-paper {
      max-height: calc(100dvh - 40px);
    }
  }
`;

export const ScrollWrapper = styled(Stack)`
  display: block;
  width: 100%;
  overflow: auto;
  position: relative;
`;
